/** FT Number is a source identifier, not an alias inferred from paymentRef.
 * Preserve leading zeroes and punctuation; never invent it for old records. */
export function ftHeader(value: string) {
  return (
    value
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "") === "ftnumber"
  );
}

export function sourceFtNumber(row: Record<string, unknown>): string {
  const values = Object.entries(row)
    .filter(([name]) => ftHeader(name))
    .map(([, value]) =>
      typeof value === "string"
        ? value.trim()
        : typeof value === "number" && Number.isSafeInteger(value) && value >= 0
          ? String(value)
          : "",
    )
    .filter(Boolean);
  const distinct = new Set(values.map((value) => value.toUpperCase()));
  return distinct.size === 1 ? values[0] : "";
}

export function comparableFtNumber(value: string | undefined) {
  return (value || "").trim().toUpperCase();
}
